import { useCallback } from 'react';
import useAllClientList from '@/features/clients/hooks/useAllClientList';
import { Client } from '@/services/API';
import useAllClientsSubscription from '@/services/subscriptions/useAllClientsSubscription';
import { MeetingSelectors } from '@/store/slices/meeting';
import { useAppDispatch, useAppSelector } from '@/store/StoreHooks';
import { deleteAClient } from '@/store/thunk/clients';
import { PageLoading } from '@/ui/PageLoading';
import AdminClientListView from './AdminClientListView';

export default function AdminClientListClient() {
  const clientsList = useAllClientList();
  const meetingList = useAppSelector(MeetingSelectors.getMeetingList);
  const dispatch = useAppDispatch();
  useAllClientsSubscription();

  const handleDeleteClient = useCallback((client: Client) => {
    dispatch(deleteAClient(client.clientName));
  }, []);

  if (!clientsList) {
    return <PageLoading />;
  }
  return (
    <AdminClientListView
      data={clientsList}
      meetingList={meetingList}
      handleDeleteClient={handleDeleteClient}
    />
  );
}
